export class DtoPedido {

	companiaSocio: string;
	tipoDocumento: string;
	numeroDocumento: string;
	estado: string;
	fechaDocumento: Date;
	clienteNombre: string;
	monedaDocumento: string;
	montoTotal: number;
	clienteNumero: number;
	comercialPedidoFechaRequerida: Date;
	fechaAprobacion: Date;
	comentarios: string;
	sucursal: string;
	unidadNegocio: string;
	formaFacturacion: string;
	impresionPendienteFlag: string;
	tipoVenta: string;
	prioridad: string;
	centroCosto: string;
	almacenCodigo: string;
	voBoComercialFlag: string;
	nomEstado: string;
	nombreMonedaDocumento: string;
	vendedorNombre: string;
	
}
